import React, { Component } from 'react';
import { WithTranslation } from 'react-i18next';
import Table from 'components/Table';
import { ProcessInstanceHistoryListItem } from '#shared/types/processInstance';
import { dateTimeFormatter } from '#web-components/utils';
import { ColumnDefinition, FilterParams } from '#web-components/types/table';
import { spacing } from '#web-components/styles';

import EndedProcessInstanceTableAction from '../EndedProcessInstanceTableAction';

interface Props extends WithTranslation {
  processInstances: Array<ProcessInstanceHistoryListItem>;
  getProcessInstances: (filterParams: FilterParams, isInitialRequest?: boolean) => void;
  filterParams: FilterParams,
  isLoadingProcess: boolean;
}

class EndedProcessInstanceTable extends Component<Props> {
  columnDefinitions: ColumnDefinition[] = [
    {
      title: this.props.t('components.processInstanceTable.columns.name'),
      property: 'processDefinitionName',
      width: 416,
      sortable: false,
    },
    {
      title: this.props.t('components.processInstanceTable.columns.businessKey'),
      property: 'businessKey',
      width: 512,
      sortable: false,
    },
    {
      title: this.props.t('components.processInstanceTable.columns.startDateTime'),
      property: 'startTime',
      formatter: dateTimeFormatter,
      width: `${spacing * 26}px`,
    },
    {
      title: this.props.t('components.processInstanceTable.columns.endDateTime'),
      property: 'endTime',
      formatter: dateTimeFormatter,
      width: `${spacing * 26}px`,
    },
    {
      title: this.props.t('components.processInstanceTable.columns.result'),
      property: 'excerptResult',
      width: 288,
      sortable: false,
      // TODO: Declare this component outside parent component "EndedProcessInstanceTable" or memoize it.
      //  If you want to allow component creation in props, set allowAsProps option to true
      // eslint-disable-next-line react/no-unstable-nested-components
      Component: ({ item }) => {
        const { status, excerptId } = item as ProcessInstanceHistoryListItem;
        return excerptId
          ? <EndedProcessInstanceTableAction excerptId={excerptId} />
          // eslint-disable-next-line react/jsx-no-useless-fragment
          : <>{status.title}</>;
      },
    },
  ];

  componentDidMount() {
    const { getProcessInstances, filterParams } = this.props;
    getProcessInstances(filterParams, true);
  }

  handleFilterChange = (filterParams: FilterParams) => {
    const { getProcessInstances } = this.props;
    getProcessInstances(filterParams, false);
  };

  render() {
    const {
      processInstances,
      filterParams: {
        page,
        rowsPerPage,
        order,
        orderField,
      },
      isLoadingProcess,
      t,
    } = this.props;

    return (
      <Table
        columnDefinitions={this.columnDefinitions}
        list={processInstances}
        order={order}
        orderField={orderField}
        emptyPlaceholder={t('components.processInstanceTable.emptyPlaceholderEnded')}
        hideEmptyPlaceholder={isLoadingProcess}
        pagination={{
          page,
          rowsPerPage,
        }}
        onFilterChange={this.handleFilterChange}
      />
    );
  }
}

export default EndedProcessInstanceTable;
